<template>
  <div class="mx-auto col-sm-8">
    <div class="row">
      <div class="form-group col-lg-12">
        <label for="engine">{{ $t('engine') }}</label>
        <Combobox
          class="bg-white"
          name='engine'
          :placeholder="$t('select_a_item')"
          :options="engines"
          :getOptionLabel="engine => engine.toUpperCase()"
          v-model="engineSelected"
          :initial-value="engineSelected"
          v-validate="'required'"
          :hasErrors="errors.has('engine')"
        />

        <small v-show="errors.has('engine')" class="form-text">
          {{ errors.first('engine') }}
        </small>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-lg-12">
        <label for="version">{{ $t('version') }}</label>
        <input
          :disabled="!engineSelected || !['here', 'tomtom'].includes(engineSelected)"
          type="text"
          id="version"
          name="version"
          class="form-control"
          :placeholder="$t('ph_version')"
          v-model="version"
        >
      </div>
    </div>

    <div class="row">
      <div class="form-group col-lg-12">
        <label for="amount_deliveries_geocode">{{ $t('amount_deliveries_geocode') }}</label>
        <input
          type="number"
          id="amount_deliveries_geocode"
          name="amount_deliveries_geocode"
          class="form-control"
          :placeholder="$t('ph_amount_deliveries_geocode')"
          v-model="amountDeliveriesToGeocode"
        >
      </div>
    </div>

    <div class="row">
      <LoaderButton
        class="ml-3"
        @click="save"
      >
        {{ $t('save') }}
      </LoaderButton>
    </div>
  </div>
</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import LoaderButton from '@/components/button/LoaderButton'
import engines from '@/config/engines'

export default {
  name: 'EngineGeocodeADD',
  components: {
    LDBsTable,
    Combobox,
    LoaderButton
  },

  data () {
    return {
      engineSelected: undefined,
      version: '',
      engines,
      amountDeliveriesToGeocode: undefined
    }
  },

  methods: {
    async save() {
      const { dispatch } = this.$store

      const isValid = await this.$validator.validateAll()

      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))

        return dispatch('notify/error', err)
      }

      await dispatch('frotix/setEngineGeocode', {
        engine: this.engineSelected,
        version: this.version,
        amountDeliveriesToGeocode: this.amountDeliveriesToGeocode
      })
    }
  }
}

</script>
